function initProductUpsell(rootElement) {
  if (!rootElement) return;

  const escapeHtml = (value) => {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  const titleCase = (value) => {
    return String(value || '')
      .split(' ')
      .filter(Boolean)
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(' ');
  };

  const formatDashTitleHtml = (rawValue) => {
    const raw = String(rawValue || '').trim();
    if (!raw) return '';

    let leftPart = raw;
    let rightPart = '';

    if (raw.includes(' - ')) {
      const parts = raw.split(' - ');
      leftPart = parts.shift() || '';
      rightPart = parts.join(' - ') || '';
    } else if (raw.includes('—')) {
      const parts = raw.split('—');
      leftPart = parts.shift() || '';
      rightPart = parts.join('—') || '';
    }

    const left = titleCase(String(leftPart || '').trim());
    const right = String(rightPart || '').trim();
    const leftHtml = `<strong>${escapeHtml(left)}</strong>`;
    if (!right) return leftHtml;
    return `${leftHtml} - ${escapeHtml(right)}`;
  };

  const sliderContainer = rootElement.querySelector('.product-upsell-slider');
  const upsellWrapper = rootElement.closest('.product-upsell') || rootElement;
  if (!sliderContainer || sliderContainer.classList.contains('initialized')) return;

  // 1. Setup Form Submission & Validation Logic for ALL items
  sliderContainer.querySelectorAll('.product-upsell__item').forEach((itemContainer) => {
    const form = itemContainer.querySelector('.product-upsell__form');
    if (!form) return;

    const submitBtn = form.querySelector('button');
    const hiddenInput = form.querySelector('input[name="id"]');
    const validationMsg = submitBtn ? submitBtn.querySelector('.product-upsell__validation-msg') : null;
    const inlineError = itemContainer.querySelector('.product-upsell__inline-error');

    // A. Form Submit (AJAX)
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      if (submitBtn.classList.contains('loading')) return;
      if (submitBtn.disabled) return;

      const activeSwatch = itemContainer.querySelector('.product-upsell__swatch-btn.active');
      if (activeSwatch && activeSwatch.dataset.variantAvailable === 'false') return;

      // Basic validation
      if (!hiddenInput.value) {
         if (validationMsg) {
            validationMsg.classList.add('active');
            setTimeout(() => {
              validationMsg.classList.remove('active');
            }, 3000);
         }
         if (inlineError) inlineError.classList.add('active');
         return;
      }

      submitBtn.classList.add('loading');
      const spinner = submitBtn.querySelector('.loading__spinner');
      const iconSvg = submitBtn.querySelector('.product-upsell__icon-svg');

      if (spinner) spinner.classList.remove('hidden');
      if (iconSvg) iconSvg.classList.add('hidden');

      const formData = new FormData(form);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();

        if (data.status) {
          console.error('Error adding to cart:', data.description);
          return;
        }

        // Publish event for other listeners
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-upsell', cartData: data });
        }

        // Explicitly update cart drawer and refresh upsell section
        const section = upsellWrapper.closest('.shopify-section');
        const sectionId = section ? section.id.replace(/^shopify-section-/, '') : null;
        
        const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble'];
        if (sectionId) sectionsToFetch.push(sectionId);

        fetch(`${window.location.pathname}?sections=${sectionsToFetch.join(',')}&t=${Date.now()}`)
          .then(res => res.json())
          .then(sections => {
            // Update Cart Drawer
            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
               // item_count: 1 ensures is-empty class is removed
               cartDrawer.renderContents({ 
                   sections: sections, 
                   item_count: 1 
               });
               cartDrawer.open(submitBtn);
            }

            // Update Product Upsell
            if (sectionId && sections[sectionId]) {
                const html = sections[sectionId];
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const newUpsell = doc.querySelector('.product-upsell');
                
                if (newUpsell) {
                    if (upsellWrapper && upsellWrapper.parentNode) {
                        upsellWrapper.outerHTML = newUpsell.outerHTML;
                        // Find the new element in DOM
                        const newElement = document.querySelector('.product-upsell'); // Assuming one per page or getting first
                        // Ideally we should scope it, but if sectionId is unique (template--...__main), there's only one main section.
                        // However, multiple product-upsell blocks could exist if multiple blocks are added.
                        // Using a more specific selector if possible?
                        // For now, let's re-query the product-upsell inside the section.
                        const newSection = document.getElementById(`shopify-section-${sectionId}`);
                        if (newSection) {
                            const newContainer = newSection.querySelector('.product-upsell');
                            if (newContainer) initProductUpsell(newContainer);
                        }
                    }
                } else {
                    // If product upsell is gone (e.g. all products in cart), remove it
                    if (upsellWrapper && upsellWrapper.parentNode) {
                        upsellWrapper.remove();
                    }
                }
            }
          });

      } catch (error) {
        console.error('Error adding to cart from product upsell:', error);
      } finally {
        // Only remove loading state if the element is still in DOM (it might be replaced)
        if (document.body.contains(submitBtn)) {
            submitBtn.classList.remove('loading');
            const spinnerEl = submitBtn.querySelector('.loading__spinner');
            const iconSvgEl = submitBtn.querySelector('.product-upsell__icon-svg');

            if (spinnerEl) spinnerEl.classList.add('hidden');
            if (iconSvgEl) iconSvgEl.classList.remove('hidden');
        }
      }
    });

    // B. Validation Click Handler
    if (submitBtn) {
        submitBtn.addEventListener('click', (e) => {
            if (!hiddenInput.value) {
                e.preventDefault();
                e.stopPropagation();
                if (validationMsg) {
                    validationMsg.classList.add('active');
                    setTimeout(() => {
                        validationMsg.classList.remove('active');
                    }, 3000);
                }
                if (inlineError) inlineError.classList.add('active');
            }
        });
    }
  });

  // 2. Setup Swatches Logic
  sliderContainer.querySelectorAll('.product-upsell__swatches').forEach((swatchContainer) => {
    const itemContainer = swatchContainer.closest('.product-upsell__item');
    const form = itemContainer.querySelector('.product-upsell__form');
    const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
    const submitBtn = form ? form.querySelector('button') : null;
    const validationMsg = submitBtn ? submitBtn.querySelector('.product-upsell__validation-msg') : null;
    const inlineError = itemContainer ? itemContainer.querySelector('.product-upsell__inline-error') : null;
    const colorNameEl = itemContainer ? itemContainer.querySelector('.product-upsell__color-name') : null;
    const defaultVariantId = itemContainer?.dataset?.defaultVariantId || '';

    const setActiveSwatch = (btn, { showTooltip = false } = {}) => {
      if (!btn) return;
      const variantId = btn.dataset.variantId;
      if (hiddenInput) hiddenInput.value = variantId;

      if (validationMsg) validationMsg.classList.remove('active');
      if (inlineError) inlineError.classList.remove('active');

      swatchContainer.querySelectorAll('.product-upsell__swatch-btn').forEach((other) => {
        other.classList.remove('active');
        other.classList.remove('tooltip-visible');
      });
      btn.classList.add('active');

      if (colorNameEl) {
        const name = btn.getAttribute('aria-label') || btn.dataset.variantTitle || '';
        colorNameEl.innerHTML = name ? formatDashTitleHtml(name) : '';
      }

      if (submitBtn) {
        const isAvailable = btn.dataset.variantAvailable !== 'false';
        submitBtn.disabled = !isAvailable;
        submitBtn.classList.toggle('is-sold-out', !isAvailable);
      }

      if (showTooltip) {
        btn.classList.add('tooltip-visible');
        if (btn.tooltipTimeout) clearTimeout(btn.tooltipTimeout);
        btn.tooltipTimeout = setTimeout(() => {
          btn.classList.remove('tooltip-visible');
          btn.tooltipTimeout = null;
        }, 2000);
      }
    };

    if (colorNameEl) colorNameEl.textContent = 'Select shade';

    swatchContainer.querySelectorAll('.product-upsell__swatch-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setActiveSwatch(btn, { showTooltip: true });
      });
    });

    if (hiddenInput && !hiddenInput.value) {
      const buttons = Array.from(swatchContainer.querySelectorAll('.product-upsell__swatch-btn'));
      const preferred = defaultVariantId
        ? buttons.find((b) => String(b.dataset.variantId) === String(defaultVariantId))
        : null;
      const firstAvailable = buttons.find((b) => b.dataset.variantAvailable !== 'false');
      setActiveSwatch(preferred || firstAvailable || buttons[0], { showTooltip: false });
    }

    const showMoreBtn = swatchContainer.querySelector('.product-upsell__show-more-btn');
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        swatchContainer.querySelectorAll('.product-upsell__swatch-btn.is-hidden').forEach((btn) => {
          btn.classList.remove('is-hidden');
        });
        showMoreBtn.style.display = 'none';
      });
    }
  });

  // 3. Setup Variant Selector Logic (Dropdown)
  sliderContainer.querySelectorAll('.product-upsell__variant-selector').forEach((selector) => {
    const selectedDiv = selector.querySelector('.product-upsell__selected-variant');
    const list = selector.querySelector('.product-upsell__variant-list');
    const itemContainer = selector.closest('.product-upsell__item');
    const form = itemContainer.querySelector('.product-upsell__form');
    const hiddenInput = form ? form.querySelector('input[name="id"]') : null;
    const colorNameEl = itemContainer ? itemContainer.querySelector('.product-upsell__color-name') : null;
    if (colorNameEl) colorNameEl.textContent = 'Select shade';
    const defaultVariantId = itemContainer?.dataset?.defaultVariantId || '';

    if (hiddenInput && !hiddenInput.value && defaultVariantId) {
      hiddenInput.value = defaultVariantId;
      if (colorNameEl) {
        const initialItem = list
          ? list.querySelector(`.product-upsell__variant-item[data-variant-id="${CSS.escape(defaultVariantId)}"]`)
          : null;
        const initialTitle = initialItem ? initialItem.dataset.variantTitle : '';
        if (initialTitle) colorNameEl.textContent = initialTitle;
      }
    }

    if (selectedDiv) {
        selectedDiv.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = selector.classList.toggle('active');
            if (list) list.classList.toggle('hidden', !isActive);

            // Close other selectors
            sliderContainer.querySelectorAll('.product-upsell__variant-selector').forEach((other) => {
                if (other !== selector) {
                    other.classList.remove('active');
                    const listEl = other.querySelector('.product-upsell__variant-list');
                    if (listEl) listEl.classList.add('hidden');
                }
            });
        });
    }

    if (list) {
        list.querySelectorAll('.product-upsell__variant-item').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.stopPropagation();
                const variantId = item.dataset.variantId;
                const title = item.dataset.variantTitle;

                if (hiddenInput) hiddenInput.value = variantId;

                const selectedInfo = selectedDiv.querySelector('.product-upsell__selected-variant-info');
                const nameSpan = selectedInfo ? selectedInfo.querySelector('.product-upsell__selected-variant-name') : null;
                if (nameSpan) {
                    nameSpan.textContent = title;
                }
                if (colorNameEl) {
                    colorNameEl.innerHTML = title ? formatDashTitleHtml(title) : '';
                }

                selector.classList.remove('active');
                list.classList.add('hidden');
            });
        });
    }
  });
  
  // Close selectors on outside click
  document.addEventListener('click', () => {
    const activeSelectors = document.querySelectorAll('.product-upsell__variant-selector.active');
    activeSelectors.forEach((selector) => {
      selector.classList.remove('active');
      const list = selector.querySelector('.product-upsell__variant-list');
      if (list) list.classList.add('hidden');
    });
  });

  // 4. Initialize KeenSlider
  if (typeof KeenSlider === 'undefined') {
    const scriptUrl =
      (upsellWrapper && upsellWrapper.dataset.keenSliderUrl) ||
      (rootElement.dataset && rootElement.dataset.keenSliderUrl);
    
    if (scriptUrl && !document.querySelector(`script[src="${scriptUrl}"]`)) {
      const script = document.createElement('script');
      script.src = scriptUrl;
      script.onload = () => initProductUpsell(rootElement);
      document.head.appendChild(script);
      return;
    } else if (scriptUrl) {
      setTimeout(() => initProductUpsell(rootElement), 100);
      return;
    }
  }

  const slides = sliderContainer.querySelectorAll('.product-upsell__item');
  const dotsContainer = rootElement.querySelector('.product-upsell__dots');

  if (slides.length <= 1) {
    if (dotsContainer) dotsContainer.style.display = 'none';
    sliderContainer.style.marginLeft = '0';
    sliderContainer.classList.add('initialized');
  } else if (typeof KeenSlider !== 'undefined') {
    if (dotsContainer) dotsContainer.style.display = 'flex';
    
    if (sliderContainer.sliderInstance) {
      sliderContainer.sliderInstance.destroy();
    }

    requestAnimationFrame(() => {
      if (!sliderContainer.isConnected) return;

      sliderContainer.sliderInstance = new KeenSlider(sliderContainer, {
        slides: {
          perView: 1,
          spacing: 15,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: { perView: 1, spacing: 15 },
          },
        },
        slideChanged: (s) => {
          if (!dotsContainer) return;
          const dots = dotsContainer.querySelectorAll('.product-upsell__dot');
          dots.forEach((dot, idx) => {
            if (idx === s.track.details.rel) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        },
        created: (s) => {
          sliderContainer.classList.add('initialized');

          if (dotsContainer) {
            dotsContainer.innerHTML = '';
            s.track.details.slides.forEach((_slide, idx) => {
              const dot = document.createElement('button');
              dot.classList.add('product-upsell__dot');
              if (idx === s.track.details.rel) {
                dot.classList.add('active');
              }
              dot.addEventListener('click', () => {
                s.moveToIdx(idx);
              });
              dotsContainer.appendChild(dot);
            });
          }
        },
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-upsell').forEach(function(container) {
    initProductUpsell(container);
  });
});
